// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.css-3hpdci-MuiSvgIcon-root-MuiStepIcon-root.Mui-active {
  color: #3f51b5 !important;
  font-size: 1.6rem !important;
}

.loaderParent {
  width: 100%;
  height: 80vh;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.mapboxgl-popup {
  max-width: 200px;
}

.mapboxgl-popup-content {
  text-align: center;
  font-family: "Open Sans", sans-serif;
}

.btn {
  background-color: #000 !important;
  color: white;
  padding: 7.5px 16px !important;
}
.theme-btn {
  background-color: #000 !important;
	color: #fff !important
}

.btn:hover {
  background-color: #000 !important;
}
.btn:disabled {
  color: #b9b9b9 !important;
  cursor: not-allowed !important;
}
.MuiInputBase-inputSizeSmall {
  height: 40px !important;
  box-sizing: border-box !important;
}
.MuiInputBase-sizeSmall fieldset.MuiOutlinedInput-notchedOutline legend, .MuiInputBase-formControl fieldset.MuiOutlinedInput-notchedOutline legend {
  max-width: 100% !important;
}
.MuiInputLabel-sizeSmall, .MuiInputLabel-sizeMedium {
  transform: translate(14px, -9px) scale(0.75) !important;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,8BAA8B;AAChC;AACA;EACE,iCAAiC;CAClC;AACD;;AAEA;EACE,iCAAiC;AACnC;AACA;EACE,yBAAyB;EACzB,8BAA8B;AAChC;AACA;EACE,uBAAuB;EACvB,iCAAiC;AACnC;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,uDAAuD;AACzD","sourcesContent":[".css-3hpdci-MuiSvgIcon-root-MuiStepIcon-root.Mui-active {\n  color: #3f51b5 !important;\n  font-size: 1.6rem !important;\n}\n\n.loaderParent {\n  width: 100%;\n  height: 80vh;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n}\n\n.mapboxgl-popup {\n  max-width: 200px;\n}\n\n.mapboxgl-popup-content {\n  text-align: center;\n  font-family: \"Open Sans\", sans-serif;\n}\n\n.btn {\n  background-color: #000 !important;\n  color: white;\n  padding: 7.5px 16px !important;\n}\n.theme-btn {\n  background-color: #000 !important;\n\tcolor: #fff !important\n}\n\n.btn:hover {\n  background-color: #000 !important;\n}\n.btn:disabled {\n  color: #b9b9b9 !important;\n  cursor: not-allowed !important;\n}\n.MuiInputBase-inputSizeSmall {\n  height: 40px !important;\n  box-sizing: border-box !important;\n}\n.MuiInputBase-sizeSmall fieldset.MuiOutlinedInput-notchedOutline legend, .MuiInputBase-formControl fieldset.MuiOutlinedInput-notchedOutline legend {\n  max-width: 100% !important;\n}\n.MuiInputLabel-sizeSmall, .MuiInputLabel-sizeMedium {\n  transform: translate(14px, -9px) scale(0.75) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
